export const hasCompatibleCartOrigin = (entry, table) => {
  const origin = String(entry?.cacheContextId || "");
  const target = String(table?.cache_context_id || "");
  const cycle = Number(entry?.occupancyCycle);
  const current = Number(table?.occupancy_cycle);
  return Boolean(origin && target && origin === target &&
    Number.isInteger(cycle) && cycle > 0 && cycle === current);
};

// Keep the complete payload in the same durable store, outside live table keys.
// Unknown legacy origins are not guessed. No age-based deletion of drafts.
export const preserveDetachedCart = (map, key, entry, reason = "occupation-changed") => {
  if (!(map instanceof Map) || !entry) return null;
  const pendingItems = entry.pendingItems || entry.currentOrder?.items || [];
  const items = entry.items || entry.existingItems || [];
  if (!pendingItems.length && !items.length) return null;
  const prefix = `preserved:${key}:`;
  const identity = JSON.stringify({ pendingItems, items, occupancyCycle: entry.occupancyCycle,
    cacheContextId: entry.cacheContextId });
  for (const [savedKey, saved] of map) {
    if (String(savedKey).startsWith(prefix) && saved.detachedIdentity === identity) return savedKey;
  }
  let savedKey = `${prefix}${Date.now()}`;
  while (map.has(savedKey)) savedKey += ":1";
  map.set(savedKey, { ...entry, pendingItems, items, detachedIdentity: identity,
    recoveryRequired: true, recoveryReason: reason, timestamp: entry.timestamp || Date.now() });
  return savedKey;
};
